import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { clearAuth } from 'src/app/store/auth/auth.actions';
import { selectAuth } from 'src/app/store/auth/auth.selector';
import { TokenAuthState } from 'src/app/store/auth/auth.state';
import { clearLocalStorage } from 'src/app/utility/local-storage';
import { environment } from 'src/environments/environment';
import { ApiService } from './api-services/api.service';
import { ChatClientService } from './chat-client.service';
import { FreshChatService } from './freshchat.service';
import { SecondaryOtpService } from './secondary-otp.service';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  auth$: TokenAuthState;
  spinner = false;
  selectedLan = new BehaviorSubject('');
  rewardQty = new BehaviorSubject([{ rewardId: null, qty: 1 }]);
  registerData = new BehaviorSubject([]);
  tabSelect = new BehaviorSubject<any>('');
  reactedOnComment = new BehaviorSubject({ postId: null, status: false });
  iframeTokenDetails = new BehaviorSubject({
    session_token: null,
    redirect_url: '',
  });

  websiteLink = environment.url.SSOUrl;
  goToSsoLinkOnLogout = environment.settings.goToSsoLinkOnLogout;

  constructor(
    private store: Store,
    private api: ApiService,
    private router: Router,
    private secondaryOtpService: SecondaryOtpService,
    private freshChatService: FreshChatService,
    private chatClientService: ChatClientService,
  ) {
    this.store.pipe(select(selectAuth)).subscribe((auth) => {
      this.auth$ = auth;
    });
  }

  isLogin() {
    if (!!this.auth$?.auth?.token) {
      return dayjs().isSame(this.auth$?.tokenDate, 'day');
    }
    return false;
  }

  setRegisterData(data: any) {
    this.registerData.next(data);
  }

  getRegisterData() {
    return this.registerData.asObservable();
  }

  isInIframe() {
    return window.self !== window.top;
  }

  async signOut() {
    this.freshChatService.resetOnLogout();
    if (this.chatClientService.isEnabled) {
      this.chatClientService.resetOnLogout();
    }

    await this.api.logOut();
    this.store.dispatch(clearAuth());

    this.secondaryOtpService.resetOtpVerification();
    clearLocalStorage();
    this.api.clearCacheStorage();

    if (this.goToSsoLinkOnLogout && this.websiteLink) {
      window.location.href = this.websiteLink;
    } else {
      this.router.navigate(['/login']);
    }
  }
}
